import { useContext, useMemo } from "react";
import AppContext from "AppContext";
import { Navigate } from "react-router-dom";
import { useProfileState } from 'hooks/useProfileState';

// Protected Routes
export function ProtectedContent({ children }) {
  const { platformUser } = useContext(AppContext);
  return platformUser ? children : <Navigate to="/" replace />;
}

// Redirect Routes
export function RedirectRoute() {
  return <Navigate to="/" replace />;
}

export function UseCheckStatusRoute({ children }) {
  const { platformUser } = useContext(AppContext);
  const { profiles, loading } = useProfileState();
  
  console.log('🔒 Route Protection Check:', {
    hasPlatformUser: !!platformUser,
    platformUserId: platformUser?.id,
    hasProfiles: !!profiles,
    profilesCount: profiles?.length,
    isLoading: loading
  });
  
  const userProfile = useMemo(() => {
    const profile = profiles?.find(p => p.user_id === platformUser?.id);
    console.log('👤 User Profile:', {
      found: !!profile,
      userId: platformUser?.id,
      profileId: profile?.id,
      profileStatus: profile?.status
    });
    return profile;
  }, [profiles, platformUser?.id]);

  const isActive = useMemo(() => {
    const active = userProfile?.status === 'active';
    console.log('✅ Active Status:', {
      isActive: active,
      status: userProfile?.status
    });
    return active;
  }, [userProfile?.status]);
  
  if (loading) {
    console.log('⌛ Loading profiles...');
    return null;
  }

  // If no user, redirect to home
  if (!platformUser) {
    console.log('🚫 No platform user - redirecting to home');
    return <Navigate to="/" replace />;
  }

  // If user has no profile or inactive, redirect to profile
  if (!isActive) {
    console.log('⚠️ Profile inactive or missing - redirecting to profile page');
    return <Navigate to="/profile" replace />;
  }

  console.log('✨ All checks passed - rendering protected content');
  // If all checks pass, render the protected content
  return children;
}
